import { useEffect } from 'react';

const DEFAULT_TITLE = 'Activation';

function usePageTitle({ text = DEFAULT_TITLE }) {
  // change title on mount and unmount
  useEffect(() => {
    document.title = `${text}`;

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [text]);
}

export default usePageTitle;
